import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { SkeletonDiv } from '../../common/SkeletonDiv';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Metrics } from '../../../metrics/Metrics';
import { useEffect } from 'react';

/**
 * @temporary We're tracking description length while actively iterating on this feature. We should remove the tracking when we're done iterating.
 * @expiration 2025-06-30
 * @deprecated
 */
import { jsx as _jsx } from "react/jsx-runtime";
const trackDescriptionLength = descriptionLength => {
  Metrics.histogram('prop_info_pop_description_length').update(descriptionLength);
};
export default function PropertyInformationPopoverDescription({
  description,
  loading
}) {
  var _description$length;
  useEffect(() => {
    if (typeof description !== 'undefined') {
      trackDescriptionLength(description.length);
    }
  }, [description]);
  if (loading && typeof description === 'undefined') {
    return /*#__PURE__*/_jsx(Flex, {
      blockSize: "24px",
      inlineSize: "100%",
      flexDirection: "row",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(SkeletonDiv, {
        blockSize: "17.5px",
        inlineSize: "100%",
        "aria-label": I18n.text('customerDataFiltersUI.propertyInformationPopover.description.loading')
      })
    });
  }

  // UITruncateMultiline won't add a tooltip if the text is truncated
  //   so we use a Text component and implement the tooltip ourselves
  // Showing the tooltip when we shouldn't isn't a big deal,
  //   so we use a rough estimation
  const isTruncated = ((_description$length = description === null || description === void 0 ? void 0 : description.length) !== null && _description$length !== void 0 ? _description$length : 0) > 150;
  const message = /*#__PURE__*/_jsx(Text, {
    as: "p" // changing this to "span" is not sufficient to make the tooltip work
    ,
    typography: "body-100",
    truncate: {
      lineClamp: 3
    },
    use: description ? 'default' : 'disabled',
    children: description || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.propertyInformationPopover.description.missing"
    })
  });
  if (isTruncated) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: description,
      children: /*#__PURE__*/_jsx("span", {
        children: message
      })
    });
  } else {
    return message;
  }
}